import { PUBLIC_INQUIRY_PATH } from '../marketing/marketingNav'

export const EARLY_BIRD_LABEL = '플랜 안내'
export const EARLY_BIRD_NOTE = 'BASIC과 ENTERPRISE는 월 구독, 단체계약은 별도 견적으로 제공합니다.'

/** 1개월 결제 기준 금액(원). */
export const TIER_MONTHLY_SUPPLY_KRW = {
  basic: 9900,
  enterprise: 29900,
}

/**
 * 1개월 정가(원). 결제/BE 빌링 시드와 운영 정책을 함께 맞춰야 합니다.
 */
export const TIER_LIST_MONTHLY_KRW = {
  basic: 9900,
  enterprise: 29900,
}

/** 12개월 선결제 금액 = 해당 티어 1개월 결제 금액 × 10 */
export function annualSupplyFromMonthly(monthlySupplyKrw) {
  const m = Number(monthlySupplyKrw) || 0
  return m * 10
}

/** 1개월: 월 정가 대비 혜택가 할인율(%), 반올림. */
export function listToSaleDiscountPercentRounded(listMonthlyKrw, saleMonthlyKrw) {
  const list = Number(listMonthlyKrw)
  const sale = Number(saleMonthlyKrw)
  if (!Number.isFinite(list) || list <= 0 || !Number.isFinite(sale) || sale >= list) return 0
  return Math.round((1 - sale / list) * 100)
}

/**
 * 12개월 선결제(혜택가×10) 할인율(%): 월 정가×12 총액 대비 (월정가×12 − 혜택가×10) / (월정가×12).
 */
export function annualPrepayDiscountVsListMonthly12PercentRounded(listMonthlyKrw, saleMonthlyKrw) {
  const list = Number(listMonthlyKrw)
  const sale = Number(saleMonthlyKrw)
  const denom = list * 12
  const numer = sale * 10
  if (!Number.isFinite(denom) || denom <= 0 || !Number.isFinite(numer)) return 0
  if (numer >= denom) return 0
  return Math.round((1 - numer / denom) * 100)
}

/**
 * 마케팅 요금표(/pricing) 카드.
 */
export const marketingPlans = [
  {
    id: 'basic',
    name: 'BASIC',
    badge: '기본',
    listMonthlyKrw: TIER_LIST_MONTHLY_KRW.basic,
    saleMonthlyKrw: TIER_MONTHLY_SUPPLY_KRW.basic,
    price: `${new Intl.NumberFormat('ko-KR').format(TIER_MONTHLY_SUPPLY_KRW.basic)}원`,
    period: '1인 · 1개월 결제 기준',
    annualHint: null,
    desc: '청구를 제외한 핵심 분석과 고객 접점 기능을 시작하는 기본 플랜입니다.',
    cta: { label: 'BASIC 가입', to: '/checkout?product=basic-1m', primary: true },
    // secondaryCta: { label: '문의하기', to: PUBLIC_INQUIRY_PATH },
    featured: false,
  },
  {
    id: 'enterprise',
    name: 'ENTERPRISE',
    badge: '무제한',
    listMonthlyKrw: TIER_LIST_MONTHLY_KRW.enterprise,
    saleMonthlyKrw: TIER_MONTHLY_SUPPLY_KRW.enterprise,
    price: `${new Intl.NumberFormat('ko-KR').format(TIER_MONTHLY_SUPPLY_KRW.enterprise)}원`,
    period: '1인 · 1개월 결제 기준',
    annualHint: null,
    desc: '보험금청구와 주요 분석 기능을 제한 없이 사용하는 확장 플랜입니다.',
    cta: { label: 'ENTERPRISE 가입', to: '/checkout?product=enterprise-1m', primary: true },
    // secondaryCta: { label: '문의하기', to: PUBLIC_INQUIRY_PATH },
    featured: true,
  },
  {
    id: 'organization-contract',
    name: '단체계약',
    badge: '조직 계약',
    listMonthlyKrw: null,
    saleMonthlyKrw: null,
    price: '별도 견적',
    period: 'GA·조직 계약 기준',
    annualHint: null,
    desc: '좌석 수, 조직 구조, 운영 범위에 맞춰 계약 조건과 할인율을 별도로 협의합니다.',
    cta: { label: '단체계약 상담', to: PUBLIC_INQUIRY_PATH, primary: false },
    featured: false,
    contractOnly: true,
  },
]

export const organizationContractPlan = marketingPlans.find((plan) => plan.id === 'organization-contract')

const tierMeta = [
  {
    id: 'basic',
    codePrefix: 'SUB_BASIC',
    name: 'BASIC',
    checkoutTitle: '베이직',
    checkoutBadge: '기본',
    monthly: TIER_MONTHLY_SUPPLY_KRW.basic,
    listMonthly: TIER_LIST_MONTHLY_KRW.basic,
  },
  {
    id: 'enterprise',
    codePrefix: 'SUB_ENTERPRISE',
    name: 'ENTERPRISE',
    checkoutTitle: '엔터프라이즈',
    checkoutBadge: '무제한',
    monthly: TIER_MONTHLY_SUPPLY_KRW.enterprise,
    listMonthly: TIER_LIST_MONTHLY_KRW.enterprise,
  },
]

/**
 * 공개 결제(/checkout) 상품 — 티어 × (1개월 | 12개월).
 */
export const checkoutProducts = tierMeta.flatMap((t) => {
  const monthlyDisc = listToSaleDiscountPercentRounded(t.listMonthly, t.monthly)
  const annual12Disc = annualPrepayDiscountVsListMonthly12PercentRounded(t.listMonthly, t.monthly)
  return [
    {
      id: `${t.id}-1m`,
      code: `${t.codePrefix}_1M`,
      tierId: t.id,
      tierName: t.name,
      name: `${t.checkoutTitle} · 1개월`,
      summary: monthlyDisc > 0 ? `1인 기준 · 1개월 이용 · ${monthlyDisc}% 할인` : '1인 기준 · 1개월 이용',
      periodLabel: '1개월',
      supplyPriceKrw: t.monthly,
      listPriceKrw: t.listMonthly,
      discountPercent: monthlyDisc,
    },
    {
      id: `${t.id}-12m`,
      code: `${t.codePrefix}_12M`,
      tierId: t.id,
      tierName: t.name,
      name: `${t.checkoutTitle} · 12개월 선결제`,
      summary: annual12Disc > 0 ? `1인 기준 · 12개월 선결제(10개월분) · ${annual12Disc}% 할인` : '1인 기준 · 12개월 선결제',
      periodLabel: '12개월',
      supplyPriceKrw: annualSupplyFromMonthly(t.monthly),
      listPriceKrw: t.listMonthly * 12,
      discountPercent: annual12Disc,
    },
  ]
})

/** 결제 화면: 요금 안내 카드 순서와 동일하게 티어별로 묶음 */
export const checkoutTierGroups = tierMeta.map((t) => ({
  id: t.id,
  title: t.checkoutTitle,
  badge: t.checkoutBadge,
  products: checkoutProducts.filter((p) => p.tierId === t.id),
}))

/**
 * 공개 체크아웃 상품 → BE 견적/주문과 동일한 planCode·period.
 * @param {{ tierName?: string, periodLabel?: string } | null | undefined} product
 */
export function billingParamsFromCheckoutProduct(product) {
  if (!product || typeof product.tierName !== 'string') {
    return { planCode: 'BASIC', period: 'MONTH' }
  }
  const planCode = String(product.tierName).toUpperCase()
  const period = product.periodLabel === '12개월' ? 'YEAR' : 'MONTH'
  return { planCode, period }
}

/** 공개 요금 비교표 — 행: basic / enterprise */
export const planComparisonSections = [
  {
    title: '영업지원',
    rows: [
      { label: '모바일 명함', basic: '제공', enterprise: '제공' },
      { label: '개인홈페이지', basic: '제공', enterprise: '제공' },
      { label: '홍보용 랜딩페이지', basic: '제공', enterprise: '제공' },
      { label: '조직배너·조직홈페이지', basic: '조직 계약 전용', enterprise: '조직 계약 전용' },
    ],
  },
  {
    title: '고객지원',
    rows: [
      { label: '고객관리', basic: '제공', enterprise: '제공' },
      { label: '보험계약·만기대장', basic: '제공', enterprise: '제공' },
      { label: '보험금청구', basic: '제외', enterprise: '무제한' },
      { label: '보험금청구 결과 알림톡', basic: '제외', enterprise: '청구 건에 포함' },
    ],
  },
  {
    title: '설계지원',
    rows: [
      { label: '진료정보분석', basic: '월 5건', enterprise: '무제한' },
      { label: '숨은보험금찾기', basic: '월 5건', enterprise: '무제한' },
      { label: '통합리포트', basic: '월 5건', enterprise: '무제한' },
      { label: '진단시뮬레이션', basic: '제공', enterprise: '무제한' },
      { label: '설계의뢰 자동 발송', basic: '제공', enterprise: '무제한' },
      { label: '3종확인서', basic: '일부 GA', enterprise: '일부 GA' },
    ],
  },
  {
    title: '업무지원',
    rows: [
      { label: '오늘의 업무브리핑 알림톡', basic: '제공', enterprise: '무제한' },
      { label: '보험사 소식지 요약', basic: '제공', enterprise: '제공' },
      { label: '교육/클래스', basic: '제공', enterprise: '제공' },
    ],
  },
]

/** 공급가에 대한 부가세율(표시용). 청구서·세금계산서는 별도 규정에 따릅니다. */
export const checkoutVatRate = 0.1

export function formatKrw(n) {
  const v = Number(n)
  if (!Number.isFinite(v)) return '-'
  return `${new Intl.NumberFormat('ko-KR').format(Math.round(v))}원`
}

export function computeVatAndTotal(supplyPriceKrw, vatRate = checkoutVatRate) {
  const supply = Number(supplyPriceKrw) || 0
  const vat = Math.round(supply * vatRate)
  return { supply, vat, total: supply + vat }
}
